module.exports = __webpack_public_path__ + "VeekshithKolanupaka-5dfcb61c.webp";